<template>
  <div class="ActionConfirmModal">
    <div class="ActionConfirmModal__content">
      <div class="ActionConfirmModal__title">{{ title }}</div>
      <div class="ActionConfirmModal__body">{{ content }}</div>
      <div
        v-if="requireDeleteConfirmation"
        class="ActionConfirmModal__delete-confirm"
      >
        <label class="ActionConfirmModal__delete-label">
          Type <strong>reject</strong> to confirm
        </label>
        <input
          v-model="deleteInput"
          class="ActionConfirmModal__delete-input"
          type="text"
          placeholder="reject"
          autocomplete="off"
        />
      </div>
      <div v-if="errorMessage" class="ActionConfirmModal__error">
        {{ errorMessage }}
      </div>
      <div class="ActionConfirmModal__footer">
        <button
          class="button button-danger"
          :disabled="loading"
          @click="$emit('cancel')"
        >
          Cancel
        </button>
        <button
          class="button button-primary"
          :disabled="
            loading || (requireDeleteConfirmation && deleteInput !== 'reject')
          "
          @click="$emit('confirm')"
        >
          <span v-if="loading">Loading...</span>
          <span v-else>Confirm</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ActionConfirmModal',
  props: {
    title: { type: String, required: true },
    content: { type: String, required: true },
    loading: { type: Boolean, default: false },
    errorMessage: { type: String, default: null },
    requireDeleteConfirmation: { type: Boolean, default: false },
  },
  data() {
    return {
      deleteInput: '',
    };
  },
};
</script>

<style lang="scss" scoped>
.ActionConfirmModal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;

  &__content {
    background: white;
    border-radius: 6px;
    padding: 24px;
    min-width: 400px;
    max-width: 500px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  }

  &__title {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 12px;
    color: #333;
  }

  &__body {
    font-size: 14px;
    color: #555;
    margin-bottom: 16px;
    line-height: 1.5;
  }

  &__error {
    background: #f8d7da;
    color: #721c24;
    padding: 10px 14px;
    border-radius: 4px;
    font-size: 13px;
    margin-bottom: 16px;
  }

  &__delete-confirm {
    margin-bottom: 16px;
  }

  &__delete-label {
    display: block;
    font-size: 13px;
    color: #555;
    margin-bottom: 6px;
  }

  &__delete-input {
    width: 100%;
    padding: 8px 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;
    box-sizing: border-box;

    &:focus {
      outline: none;
      border-color: #888;
    }
  }

  &__footer {
    display: flex;
    gap: 8px;
    justify-content: flex-end;
  }
}
</style>
